(function ($) {
    $(document).ready(function () {
        $('#celular').mask('(00) 00000-0000');
    })
})(jQuery);